import {createAction, props} from "@ngrx/store";

const setIsOnline = createAction(
  '[Body Component] Imposta status online/offline',
  props<{isOnline: boolean}>()
)

export const CoreActions = {
  setIsOnline
}
